import React from 'react';
import { Spin } from 'antd';
import styles from './styles/loading-spinner.module.scss';

/**
 * Spinner plus a status line.
 *
 * Two layouts, because the places that need one are shaped differently. The
 * default is a block loader — centered, padded, owning its vertical space —
 * for a surface that has nothing else to show yet. `inline` is a single
 * left-aligned row, for a status line that shares a slot with a card's error
 * and empty states and has to read as one of them rather than as a takeover.
 *
 * @param {Object} props
 * @param {'small' | 'default' | 'large'} [props.size]
 * @param {string} [props.text] The status line. Falsy renders the spinner alone.
 * @param {boolean} [props.inline] Render as a row instead of a centered block.
 */
const LoadingSpinner = ({ size = 'default', text = 'Loading...', inline = false }) => {
    const className = inline
        ? `${styles.loadingContainer} ${styles.inline}`
        : styles.loadingContainer;

    return (
        <div className={className}>
            <Spin size={size} />
            {text && <span className={styles.loadingText}>{text}</span>}
        </div>
    );
};

export default LoadingSpinner;
